export const adminConstants = {
  FETCH_CLIENTS_SUCCESS: 'FETCH_CLIENTS_SUCCESS',
  FETCH_CLIENTS_LOADING: 'FETCH_CLIENTS_LOADING',
  FETCH_CLIENTS_ERROR: 'FETCH_CLIENTS_ERROR',

  FETCH_FAMILIARIZATION_FORMS_FOR_CLIENT_LOADING: 'FETCH_FAMILIARIZATION_FORMS_FOR_CLIENT_LOADING',
  FETCH_FAMILIARIZATION_FORMS_FOR_CLIENT_SUCCESS: 'FETCH_FAMILIARIZATION_FORMS_FOR_CLIENT_SUCCESS',
  FETCH_FAMILIARIZATION_FORMS_FOR_CLIENT_ERROR: 'FETCH_FAMILIARIZATION_FORMS_FOR_CLIENT_ERROR',

  FETCH_BOATS_FOR_CLIENT_LOADING: 'FETCH_BOATS_FOR_CLIENT_LOADING',
  FETCH_BOATS_FOR_CLIENT_SUCCESS: 'FETCH_BOATS_FOR_CLIENT_SUCCESS',
  FETCH_BOATS_FOR_CLIENT_ERROR: 'FETCH_BOATS_FOR_CLIENT_ERROR',
  FETCH_BOATS_FOR_CLIENTS_LOADING: 'FETCH_BOATS_FOR_CLIENTS_LOADING',
  FETCH_BOATS_FOR_CLIENTS_SUCCESS: 'FETCH_BOATS_FOR_CLIENTS_SUCCESS',
  FETCH_BOATS_FOR_CLIENTS_ERROR: 'FETCH_BOATS_FOR_CLIENTS_ERROR',

  FETCH_CLIENT_USER_LINKS_ADMIN_LOADING: 'FETCH_CLIENT_USER_LINKS_ADMIN_LOADING',
  FETCH_CLIENT_USER_LINKS_ADMIN_SUCCESS: 'FETCH_CLIENT_USER_LINKS_ADMIN_SUCCESS',
  FETCH_CLIENT_USER_LINKS_ADMIN_ERROR: 'FETCH_CLIENT_USER_LINKS_ADMIN_ERROR',

  FETCH_CLIENT_USER_LINKS_LOADING: 'FETCH_CLIENT_USER_LINKS_LOADING',
  FETCH_CLIENT_USER_LINKS_SUCCESS: 'FETCH_CLIENT_USER_LINKS_SUCCESS',
  FETCH_CLIENT_USER_LINKS_ERROR: 'FETCH_CLIENT_USER_LINKS_ERROR',

  FETCH_BOATS_FOR_ACCESS_GROUP_LOADING: 'FETCH_BOATS_FOR_ACCESS_GROUP_LOADING',
  FETCH_BOATS_FOR_ACCESS_GROUP_SUCCESS: 'FETCH_BOATS_FOR_ACCESS_GROUP_SUCCESS',
  FETCH_BOATS_FOR_ACCESS_GROUP_ERROR: 'FETCH_BOATS_FOR_ACCESS_GROUP_ERROR',

  FETCH_CLIENT_ACCESS_GROUPS_LOADING: 'FETCH_CLIENT_ACCESS_GROUPS_LOADING',
  FETCH_CLIENT_ACCESS_GROUPS_SUCCESS: 'FETCH_CLIENT_ACCESS_GROUPS_SUCCESS',
  FETCH_CLIENT_ACCESS_GROUPS_ERROR: 'FETCH_CLIENT_ACCESS_GROUPS_ERROR',

  FETCH_BOAT_USER_LINKS_LOADING: 'FETCH_BOAT_USER_LINKS_LOADING',
  FETCH_BOAT_USER_LINKS_SUCCESS: 'FETCH_BOAT_USER_LINKS_SUCCESS',
  FETCH_BOAT_USER_LINKS_ERROR: 'FETCH_BOAT_USER_LINKS_ERROR',

  SAVING_NEW_CLIENT_USER_LINK_LOADING: 'SAVING_NEW_CLIENT_USER_LINK_LOADING',
  SAVING_NEW_CLIENT_USER_LINK_SUCCESS: 'SAVING_NEW_CLIENT_USER_LINK_SUCCESS',
  SAVING_NEW_CLIENT_USER_LINK_ERROR: 'SAVING_NEW_CLIENT_USER_LINK_ERROR',

  CREATE_BOAT_ACCESS_LINK_LOADING: 'CREATE_BOAT_ACCESS_LINK_LOADING',
  CREATE_BOAT_ACCESS_LINK_SUCCESS: 'CREATE_BOAT_ACCESS_LINK_SUCCESS',
  CREATE_BOAT_ACCESS_LINK_ERROR: 'CREATE_BOAT_ACCESS_LINK_ERROR',

  CREATE_NEW_CLIENT_ACCESS_GROUP_LOADING: 'CREATE_NEW_CLIENT_ACCESS_GROUP_LOADING',
  CREATE_NEW_CLIENT_ACCESS_GROUP_SUCCESS: 'CREATE_NEW_CLIENT_ACCESS_GROUP_SUCCESS',
  CREATE_NEW_CLIENT_ACCESS_GROUP_ERROR: 'CREATE_NEW_CLIENT_ACCESS_GROUP_ERROR',

  DELETE_USER_FROM_BOAT_LOADING: 'DELETE_USER_FROM_BOAT_LOADING',
  DELETE_USER_FROM_BOAT_SUCCESS: 'DELETE_USER_FROM_BOAT_SUCCESS',
  DELETE_USER_FROM_BOAT_ERROR: 'DELETE_USER_FROM_BOAT_ERROR',

  DELETE_ACCESS_GROUP_LOADING: 'DELETE_ACCESS_GROUP_LOADING',
  DELETE_ACCESS_GROUP_SUCCESS: 'DELETE_ACCESS_GROUP_SUCCESS',
  DELETE_ACCESS_GROUP_ERROR: 'DELETE_ACCESS_GROUP_ERROR',

  FETCH_MAIN_VESSEL_DECAYS_LOADING: 'FETCH_MAIN_VESSEL_DECAYS_LOADING',
  FETCH_MAIN_VESSEL_DECAYS_SUCCESS: 'FETCH_MAIN_VESSEL_DECAYS_SUCCESS',
  FETCH_MAIN_VESSEL_DECAYS_ERROR: 'FETCH_MAIN_VESSEL_DECAYS_ERROR',

  FETCH_GLOBAL_COUNTER_SERVICES_FOR_CLIENT_LOADING: 'FETCH_GLOBAL_COUNTER_SERVICES_FOR_CLIENT_LOADING',
  FETCH_GLOBAL_COUNTER_SERVICES_FOR_CLIENT_SUCCESS: 'FETCH_GLOBAL_COUNTER_SERVICES_FOR_CLIENT_SUCCESS',
  FETCH_GLOBAL_COUNTER_SERVICES_FOR_CLIENT_ERROR: 'FETCH_GLOBAL_COUNTER_SERVICES_FOR_CLIENT_ERROR',

  FETCH_GLOBAL_CALENDAR_SERVICES_FOR_CLIENT_LOADING: 'FETCH_GLOBAL_CALENDAR_SERVICES_FOR_CLIENT_LOADING',
  FETCH_GLOBAL_CALENDAR_SERVICES_FOR_CLIENT_SUCCESS: 'FETCH_GLOBAL_CALENDAR_SERVICES_FOR_CLIENT_SUCCESS',
  FETCH_GLOBAL_CALENDAR_SERVICES_FOR_CLIENT_ERROR: 'FETCH_GLOBAL_CALENDAR_SERVICES_FOR_CLIENT_ERROR',

  CREATE_SERVICE_LOADING: 'CREATE_SERVICE_LOADING',
  CREATE_SERVICE_SUCCESS: 'CREATE_SERVICE_SUCCESS',
  CREATE_SERVICE_ERROR: 'CREATE_SERVICE_ERROR',

  FETCH_BOAT_COUNTERS_FOR_BOAT_LOADING: 'FETCH_BOAT_COUNTERS_FOR_BOAT_LOADING',
  FETCH_BOAT_COUNTERS_FOR_BOAT_SUCCESS: 'FETCH_BOAT_COUNTERS_FOR_BOAT_SUCCESS',
  FETCH_BOAT_COUNTERS_FOR_BOAT_ERROR: 'FETCH_BOAT_COUNTERS_FOR_BOAT_ERROR ',

  FETCH_GLOBAL_SERVICE_MAP_FOR_BOAT_LOADING: 'FETCH_GLOBAL_SERVICE_MAP_FOR_BOAT_LOADING',
  FETCH_GLOBAL_SERVICE_MAP_FOR_BOAT_SUCCESS: 'FETCH_GLOBAL_SERVICE_MAP_FOR_BOAT_SUCCESS',
  FETCH_GLOBAL_SERVICE_MAP_FOR_BOAT_ERROR: 'FETCH_GLOBAL_SERVICE_MAP_FOR_BOAT_ERROR',

  FETCH_GLOBAL_SERVICE_MAP_FOR_CLIENT_LOADING: 'FETCH_GLOBAL_SERVICE_MAP_FOR_CLIENT_LOADING',
  FETCH_GLOBAL_SERVICE_MAP_FOR_CLIENT_SUCCESS: 'FETCH_GLOBAL_SERVICE_MAP_FOR_CLIENT_SUCCESS',
  FETCH_GLOBAL_SERVICE_MAP_FOR_CLIENT_ERROR: 'FETCH_GLOBAL_SERVICE_MAP_FOR_CLIENT_ERROR',

  ACTIVATE_GLOBAL_SERVICE_ON_BOAT_LOADING: 'ACTIVATE_GLOBAL_SERVICE_ON_BOAT_LOADING',
  ACTIVATE_GLOBAL_SERVICE_ON_BOAT_SUCCESS: 'ACTIVATE_GLOBAL_SERVICE_ON_BOAT_SUCCESS',
  ACTIVATE_GLOBAL_SERVICE_ON_BOAT_ERROR: 'ACTIVATE_GLOBAL_SERVICE_ON_BOAT_ERROR',

  DEACTIVATE_GLOBAL_SERVICE_ON_BOAT_LOADING: 'DEACTIVATE_GLOBAL_SERVICE_ON_BOAT_LOADING',
  DEACTIVATE_GLOBAL_SERVICE_ON_BOAT_SUCCESS: 'DEACTIVATE_GLOBAL_SERVICE_ON_BOAT_SUCCESS',
  DEACTIVATE_GLOBAL_SERVICE_ON_BOAT_ERROR: 'DEACTIVATE_GLOBAL_SERVICE_ON_BOAT_ERROR',

  FETCH_COUNTER_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_LOADING:
    'FETCH_COUNTER_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_LOADING',
  FETCH_COUNTER_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_SUCCESS:
    'FETCH_COUNTER_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_SUCCESS',
  FETCH_COUNTER_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_ERROR:
    'FETCH_COUNTER_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_ERROR',

  FETCH_CALENDAR_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_LOADING:
    'FETCH_CALENDAR_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_LOADING',
  FETCH_CALENDAR_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_SUCCESS:
    'FETCH_CALENDAR_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_SUCCESS',
  FETCH_CALENDAR_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_ERROR:
    'FETCH_CALENDAR_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_ERROR',

  FETCH_COUNTER_SERVICES_RIGHT_ON_BOAT_LOADING: 'FETCH_COUNTER_SERVICES_RIGHT_ON_BOAT_LOADING',
  FETCH_COUNTER_SERVICES_RIGHT_ON_BOAT_SUCCESS: 'FETCH_COUNTER_SERVICES_RIGHT_ON_BOAT_SUCCESS',
  FETCH_COUNTER_SERVICES_RIGHT_ON_BOAT_ERROR: 'FETCH_COUNTER_SERVICES_RIGHT_ON_BOAT_ERROR',

  FETCH_CALENDAR_SERVICES_RIGHT_ON_BOAT_LOADING: 'FETCH_CALENDAR_SERVICES_RIGHT_ON_BOAT_LOADING',
  FETCH_CALENDAR_SERVICES_RIGHT_ON_BOAT_SUCCESS: 'FETCH_CALENDAR_SERVICES_RIGHT_ON_BOAT_SUCCESS',
  FETCH_CALENDAR_SERVICES_RIGHT_ON_BOAT_ERROR: 'FETCH_CALENDAR_SERVICES_RIGHT_ON_BOAT_ERROR',

  FETCH_SUPPLIERS_FOR_CLIENT_LOADING: 'FETCH_SUPPLIERS_FOR_CLIENT_LOADING',
  FETCH_SUPPLIERS_FOR_CLIENT_SUCCESS: 'FETCH_SUPPLIERS_FOR_CLIENT_SUCCESS',
  FETCH_SUPPLIERS_FOR_CLIENT_ERROR: 'FETCH_SUPPLIERS_FOR_CLIENT_ERROR',

  FETCH_MAINTENANCE_HISTORY_FOR_CLIENT_LOADING: 'FETCH_MAINTENANCE_HISTORY_FOR_CLIENT_LOADING',
  FETCH_MAINTENANCE_HISTORY_FOR_CLIENT_SUCCESS: 'FETCH_MAINTENANCE_HISTORY_FOR_CLIENT_SUCCESS',
  FETCH_MAINTENANCE_HISTORY_FOR_CLIENT_ERROR: 'FETCH_MAINTENANCE_HISTORY_FOR_CLIENT_ERROR',

  FETCH_MAINTENANCE_REPORT_FOR_BOAT_AND_CLIENT_LOADING: 'FETCH_MAINTENANCE_REPORT_FOR_BOAT_AND_CLIENT_LOADING',
  FETCH_MAINTENANCE_REPORT_FOR_BOAT_AND_CLIENT_SUCCESS: 'FETCH_MAINTENANCE_REPORT_FOR_BOAT_AND_CLIENT_SUCCESS',
  FETCH_MAINTENANCE_REPORT_FOR_BOAT_AND_CLIENT_ERROR: 'FETCH_MAINTENANCE_REPORT_FOR_BOAT_AND_CLIENT_ERROR',

  DELETE_CREW_FROM_BOAT_LOADING: 'DELETE_CREW_FROM_BOAT_LOADING',
  DELETE_CREW_FROM_BOAT_SUCCESS: 'DELETE_CREW_FROM_BOAT_SUCCESS',
  DELETE_CREW_FROM_BOAT_ERROR: 'DELETE_CREW_FROM_BOAT_ERROR',
}
